import { render, staticRenderFns } from "./MainBanners.vue?vue&type=template&id=4c2ce54d&"
import script from "./MainBanners.vue?vue&type=script&lang=js&"
export * from "./MainBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports